import React from "react";

export default function Loading() {
  return (
    <div className="app-loading-overlay" role="status" aria-live="polite">
      <div className="loading_box">
        <div className="spinner" />
        <div className="loading_text">Loading…</div>
      </div>
    </div>
  );
}